<script setup>
import VideoPlayer from './VideoPlayer.vue'
import VerticalNowPlaying from './nowplaying/VerticalNowPlaying.vue'
import PromoBanner from './promobanner/PromoBanner.vue'
</script>

<template>
  <div class="flex-1 flex md:pl-12 md:pr-12 lg:pr-0 py-6 space-x-12">
    <div class="flex-1">
      <VideoPlayer />
    </div>
    <div class="hidden lg:block w-2/5 2xl:pt-6">
      <VerticalNowPlaying />
      <PromoBanner />
    </div>
  </div>
</template>
